var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"visa-types grid-row grid-gap-3 margin-top-1",class:[_vm.data.fields.styleInstructions, _vm.parentClass]},_vm._l((_vm.data.fields.cardReferences),function(visaType,i){return _c('document-renderer',{key:i,attrs:{"documentId":visaType.sys.id,"additionaldata":{ instruction:_vm.data.fields.styleInstructions }}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }